import React, { useMemo } from 'react';
import { Inline } from '@therms/atalaya';
import { useLocalStorage } from 'beautiful-react-hooks';
import { CopyJSONSchema } from './CopyJSONSchema';
import { useParams } from 'react-router-dom';
import { Tabs } from '@therms/atalaya';
import JSONSchemaDisplayer from './JSONSchemaDisplayer';
import 'react-json-pretty/themes/monikai.css';
import './JSONSchemaContainer.css';

export const JSONSchemaContainer = ({ jsonSchema, jsonSchemaTypeName }) => {
  const params = useParams();

  const [currentSchemaTabIndex, setCurrentSchemaTabIndex] = useLocalStorage(
    'currentSchemaTabIndex',
    0,
  );

  const schemaLanguage = useMemo(() => {
    if (currentSchemaTabIndex === 1) {
      return 'kotlin';
    } else if (currentSchemaTabIndex === 2) {
      return 'swift';
    } else if (currentSchemaTabIndex === 3) {
      return 'typescript';
    } else {
      return 'json';
    }
  }, [currentSchemaTabIndex]);

  return (
    <div className="min-h-500 relative">
      {jsonSchema && (
        <div className="jsonSchema">
            <Inline alignX="end">
              <Tabs
                alignX="stretch"
                initialTabIndex={currentSchemaTabIndex}
                noBottomBorder
                onTabClick={(index) => setCurrentSchemaTabIndex(index)}
              >
                <Tabs.Tab name="JSON-schema" />
                <Tabs.Tab name="Kotlin" />
                <Tabs.Tab name="Swift" />
                <Tabs.Tab name="TypeScript" />
              </Tabs>
            </Inline>

          <div className="p-1">
            <JSONSchemaDisplayer
              jsonSchema={jsonSchema}
              jsonSchemaTypeName={jsonSchemaTypeName}
              schemaLanguage={schemaLanguage}
            />
          </div>
        </div>
      )}
    </div>
  );
};
